<template>
  <div class="enter-details">
    <text-input
      :autofocus="true"
      :labelText="'שם פרטי'"
      :value="firstName"
      :onInput="setFirstName"
      :error="false"
      :topLeftLabel="''"/>

    <text-input
      :autofocus="false"
      :labelText="'שם משפחה'"
      :value="lastName"
      :onInput="setLastName"
      :error="false"
      :topLeftLabel="''"/>

    <text-input
      :autofocus="false"
      :labelText="'מס׳ נייד'"
      :value="phoneNumber"
      :onInput="setPhoneNumber"
      :inputType="'text'"
      :inputPattern="'\\d*'"
      :error="!!error"
      :topLeftLabel="phoneNumberErrorLabel"/>

    <div class="button-container">
      <riseup-button class="send-code-button" :disabled="disabled" :title="'שלחו לי קוד אימות'" :size="'small'" :action="triggerAction"/>
    </div>
    <div class="action" v-on:click="goToLogin">כבר הצטרפת לשירות? הכניסה מכאן</div>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import Segment from '../Segment';

const ERRORS = {
  INVALID_PHONE_NUMBER: 'INVALID_PHONE_NUMBER',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
  MEBMBER: 'UNKNOWN_ERROR',
  MEMBER_ALREADY_EXISTS: 'MEMBER_ALREADY_EXISTS',
};

export default {
  name: 'EnterDetails',
  components: {
    TextInput: BaseUI.TextInput,
    RiseupButton: BaseUI.RiseupButton,
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      phoneNumber: '',
      enteredBadNumber: false,
    };
  },
  props: {
    action: {
      type: Function,
      required: true,
    },
    error: {
      type: String,
      required: true,
    },
    resetError: {
      type: Function,
      required: true,
    },
  },
  computed: {
    disabled() {
      return (_.trim(this.firstName).length < 2 ||
        _.trim(this.lastName).length < 2 ||
        this.enteredBadNumber ||
        _.isEmpty(_.trim(this.phoneNumber)));
    },
    phoneNumberErrorLabel() {
      if (this.error === ERRORS.INVALID_PHONE_NUMBER) {
        Segment.trackUserGot('invalidPhoneNumber', { invalidPhoneNumber: this.phoneNumber });
        this.setBadNumber();
        return 'מספר הטלפון שהזנת לא תקין';
      } else if (this.error === ERRORS.MEMBER_ALREADY_EXISTS) {
        this.setBadNumber();
        return 'היי, נראה שכבר הצטרפת בעבר לשירות';
      }
      return null;
    },
    normalizedPhoneNumber() {
      return this.phoneNumber.replace(/\D/g, '');
    },
  },
  methods: {
    setBadNumber() {
      this.enteredBadNumber = true;
    },
    setFirstName(value) {
      this.firstName = value;
    },
    setLastName(value) {
      this.lastName = value;
    },
    setPhoneNumber(value) {
      this.resetError();
      this.phoneNumber = value;
      this.enteredBadNumber = false;
    },
    triggerAction() {
      this.action(this.firstName, this.lastName, this.normalizedPhoneNumber);
    },
    goToLogin() {
      window.location.href = '/sr';
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../node_modules/base-ui/src/scss/riseup-colors';
  .enter-details {

    .button-container {
      wudth: 100%;
      .send-code-button {
        width: 100%;
      }
    }

    .action {
      margin: 36px 0px;
      color: $riseup_light_blue;
      font-weight: bold;
      cursor: pointer;
      text-decoration: underline;
      font-size: 16px;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/base-components/EnterDetails.vue